var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"item_quesion"},[_c('div',{staticClass:"content_question row"},[_c('div',{staticClass:"item_answer"},[_c(_vm.dynamicComponent,{tag:"component",model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }